import { Component, Vue } from 'vue-property-decorator'
import { WINNERS_BTN } from '~/plugins/feature-flags/flags'
import { WINNERS_BTN_VISIBLE } from '~/plugins/feature-flags/variants'
import { HEADER_WINNERS_BUTTON_CLICK } from '~/plugins/mixpanel/events'
import { WINNERS_BUTTON_LOCATION } from '~/plugins/mixpanel/props'

@Component
export default class WinnersBtnFeature extends Vue {
  getWinnersBtnFeatureEnabled() {
    return this.$featureFlags?.isEnabled(WINNERS_BTN)
  }

  getWinnersBtnFeatureVariant() {
    return this.$featureFlags?.getVariant(WINNERS_BTN)?.name
  }

  getWinnersBtnFeatureVisible() {
    return (
      this.getWinnersBtnFeatureEnabled() &&
      this.getWinnersBtnFeatureVariant() === WINNERS_BTN_VISIBLE
    )
  }

  trackWinnersBtnClick(location: string) {
    this.$mixpanel.track(HEADER_WINNERS_BUTTON_CLICK, {
      [WINNERS_BUTTON_LOCATION]: location
    })
  }
}
